export class PhoneNumberAlreadyExistError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'PhoneNumberAlreadyExistError';
    Object.setPrototypeOf(this, PhoneNumberAlreadyExistError.prototype);
  }
}
